import BilingualSection from "../../../../src/components/BilingualSection/index.js";
import image1 from "../../../../static/msatp/images/workingguideimage1.jpeg";
import image2 from "../../../../static/msatp/images/workingguideimage2.jpeg";
import image3 from "../../../../static/msatp/images/workingguideimage3.jpeg";
import downBracket from "../../../../static/msatp/images/downbracket.png";
import twoArrows from "../../../../static/msatp/images/twoarrows.png";
import * as React from 'react';
export default {
  BilingualSection,
  image1,
  image2,
  image3,
  downBracket,
  twoArrows,
  React
};